import { styled } from '@mui/material/styles';

export const RouteMapRoot = styled('div')({
	position: 'relative',
	height: '100%',
	width: '100%',
});

export const RouteMapLoaderContainer = styled('div')({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
});

export const RouteMapDiv = styled('div')({
	height: '100%',
});
